<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">Print Box Office Tickets</div>
    <div class="section-title mb-4">
      <button @click="goToRoute()" class="btn-outline-blue-lg bg-transparent text-dark mr-1">print</button>
    </div>
    <div style class="white-wrapper">
      <div class="print-tickets mb-1">
        <table border="1" style="width:430px;line-height:1;border-color:#D3D3D3">
          <tr>
            <td colspan="3" style="padding:2px 10px;">
              <table style="width:100%">
                <tr>
                  <td style="vertical-align:top;">
                    <p style="font-size:18px;font-weight:600;margin:0">P</p>
                  </td>
                  <td>
                    <p
                      style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                    >PRABHAT TALKIES - SOLAPUR</p>
                    <p
                      style="font-size:12px;font-weight:500;margin: 0;display: flex;justify-content: space-between;"
                    >
                      <span>MADE IN CHINA U/A</span>
                      <span
                        style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                      >Transaction No: A0302206A</span>
                    </p>
                    <span
                      style="font-size: 14px; margin: 0px 0px 5px;"
                    >Issued on: 25-Oct-2019 11:04:00 AM</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="width:33.33%;padding:5px 10px;">
              <p style="font-size:10px;margin:0 0 5px 0;">ADM 94.92</p>
              <p style="font-size:10px;margin:0 0 5px 0;">CGST</p>
              <p style="font-size:10px;margin:0 0 5px 0;">SGST 08.97</p>
              <p style="font-size:12px;font-weight:600;margin:0;">Total: 120.00</p>
            </td>
            <td style="width:33.33%;padding:5px 10px;vertical-align:top;">
              <p style="font-size:14px;font-weight:600;margin:0 0 5px 0;">Fri, 25-10-2019</p>
              <p style="font-size:14px;font-weight:600;margin:0 0 10px 0;">Mat, 12:30 PM</p>
            </td>
            <td style="width:33.33%;padding:5px 10px;vertical-align:bottom">
              <p style="font-size:14px;font-weight:600;margin:0 0 5px 0">C-16</p>
              <p style="font-size:14px;font-weight:600;margin:0;">BALCONY</p>
            </td>
          </tr>
        </table>
      </div>

      <!--  -->
      <!--  -->
      <div
        ref="printnewticket"
        id="PrintTicketNewIDIDID"
        style="transform: rotate(90deg);display: table;margin: 0 auto;"
      >
        <div class="print-tickets mb-1">
          <table border="1" style="width:430px;line-height:1;border-color:#D3D3D3">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">P</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >PRABHAT TALKIES - SOLAPUR</p>
                      <p
                        style="font-size:12px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>MADE IN CHINA U/A</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: A0302206A</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: 25-Oct-2019 11:04:00 AM</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:5px 10px;">
                <p style="font-size:10px;margin:0 0 5px 0;">ADM 94.92</p>
                <p style="font-size:10px;margin:0 0 5px 0;">CGST</p>
                <p style="font-size:10px;margin:0 0 5px 0;">SGST 08.97</p>
                <p style="font-size:12px;font-weight:600;margin:0;">Total: 120.00</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:top;">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0;">Fri, 25-10-2019</p>
                <p style="font-size:14px;font-weight:600;margin:0 0 10px 0;">Mat, 12:30 PM</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:bottom">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0">C-16</p>
                <p style="font-size:14px;font-weight:600;margin:0;">BALCONY</p>
              </td>
            </tr>
          </table>
        </div>
        <div class="print-tickets mb-1">
          <table border="1" style="width:430px;line-height:1;border-color:#D3D3D3">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">P</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >PRABHAT TALKIES - SOLAPUR</p>
                      <p
                        style="font-size:12px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>MADE IN CHINA U/A</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: A0302206A</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: 25-Oct-2019 11:04:00 AM</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:5px 10px;">
                <p style="font-size:10px;margin:0 0 5px 0;">ADM 94.92</p>
                <p style="font-size:10px;margin:0 0 5px 0;">CGST</p>
                <p style="font-size:10px;margin:0 0 5px 0;">SGST 08.97</p>
                <p style="font-size:12px;font-weight:600;margin:0;">Total: 120.00</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:top;">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0;">Fri, 25-10-2019</p>
                <p style="font-size:14px;font-weight:600;margin:0 0 10px 0;">Mat, 12:30 PM</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:bottom">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0">C-16</p>
                <p style="font-size:14px;font-weight:600;margin:0;">BALCONY</p>
              </td>
            </tr>
          </table>
        </div>
        <div class="print-tickets">
          <table border="1" style="width:430px;line-height:1;border-color:#D3D3D3">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">P</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >PRABHAT TALKIES - SOLAPUR</p>
                      <p
                        style="font-size:12px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>MADE IN CHINA U/A</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: A0302206A</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: 25-Oct-2019 11:04:00 AM</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:5px 10px;">
                <p style="font-size:10px;margin:0 0 5px 0;">ADM 94.92</p>
                <p style="font-size:10px;margin:0 0 5px 0;">CGST</p>
                <p style="font-size:10px;margin:0 0 5px 0;">SGST 08.97</p>
                <p style="font-size:12px;font-weight:600;margin:0;">Total: 120.00</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:top;">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0;">Fri, 25-10-2019</p>
                <p style="font-size:14px;font-weight:600;margin:0 0 10px 0;">Mat, 12:30 PM</p>
              </td>
              <td style="width:33.33%;padding:5px 10px;vertical-align:bottom">
                <p style="font-size:14px;font-weight:600;margin:0 0 5px 0">C-16</p>
                <p style="font-size:14px;font-weight:600;margin:0;">BALCONY</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Printd from "printd";

export default {
  methods: {
    goToRoute: function() {
      this.isReprint = true;
      const p = new Printd();
      p.print(this.$refs.printnewticket, []);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/printTickets.vue